import React from "react";
import { Link } from "react-router-dom";
import "./WelcomePage.css";
import Logo from "../assets/logo.jpg";

const WelcomePage = () => {
  return (
    <section
      className="banner"
      aria-label="LushDesire Personal Wellness Store Banner"
    >
      <div className="banner-content">
        {/* ✅ SEO H1 */}
        <h1>
          LushDesire <br />
          <span>Desire that ignites your world!</span>
        </h1>

        {/* ✅ SHOP NOW → FOR MEN */}
        <Link to="/men" aria-label="Shop Men Wellness Products">
          <button className="shop-btn">SHOP NOW</button>
        </Link>
      </div>

      <div className="banner-image">
        {/* ✅ LOGO → ABOUT US */}
        <Link to="/about" aria-label="About LushDesire Brand">
         <img
         src={Logo}
           alt="LushDesire brand logo - discreet personal wellness store"
            loading="eager"
          />
        </Link>
      </div>
    </section>
  );
};

export default WelcomePage;
